import PropTypes from "prop-types"
import {connect} from "react-redux"

const PermissionComponent = (props: any) => {
    let couldShow = false
    props.permission.forEach((item: any) => {
        if (props.userPermissions === item) {couldShow = true}
    })

    return couldShow ? (props.children as JSX.Element) : null
}

PermissionComponent.propTypes = {
    permission: PropTypes.array.isRequired,
    userPermissions: PropTypes.string.isRequired,
}

const mapStateToProps = (state: {application: {permissions: {roleId: any}}}) => ({
    userPermissions: state.application.permissions.roleId,
})

export const ShowForPermission = connect(mapStateToProps)(PermissionComponent)
